import { find } from 'lodash';
import { isEmpty, l } from 'src/utils/helper';
import {
  channels,
  channelType,
  overseerCommandType,
  overseerTeamCommandType,
  watchtowerCommandType,
  roomCommandType,
} from './common';

const isCommandType = (anyCommandType, type) => !!find(anyCommandType, (v) => v === type);

const getChannelName = (type) => {
  let name = '';
  if (isCommandType(roomCommandType, type)) {
    name = channelType.ROOM;
  } else if (isCommandType(watchtowerCommandType, type)) {
    name = channelType.WATCHTOWER;
  } else if (isCommandType(overseerTeamCommandType, type)) {
    name = channelType.OVERSEER_TEAM;
  } else if (isCommandType(overseerCommandType, type)) {
    name = channelType.OVERSEER;
  }
  return name;
};

const push = (id, type, msg) => {
  const name = getChannelName(type);
  if (isEmpty(name)) {
    l.error(`Имя канала для команды ${type} не найдено! id: ${id}, сообщение: ${JSON.stringify(msg)}`);
    return undefined;
  }
  const activityChannel = channels.get(`${name}:${id}`);
  if (!activityChannel) {
    l.error(`Канал активности ${id} не найден! Скорее всего активность уже была закрыта.`
      + ` Тип ${type}, сообщение: ${JSON.stringify(msg)}`);
    return undefined;
  }
  const pushPromise = activityChannel.push(type, msg);
  l.info(`Отправлено сообщение: type: ${type}. Имя канала ${name}:${id}, cообщение: ${JSON.stringify(msg)}`);
  return pushPromise;
};

export default push;
